import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "18",
      cy: "18",
      r: "17",
      fill: "#161616",
      stroke: "white",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M10 18.8571C10 18.8571 15.75 24.1874 16.3125 24.1874C16.875 24.1874 26 12 26 12",
      stroke: "white",
      "stroke-width": "2"
    }, null, -1)
  ]))]))
}
export default { render: render }